import type { SelfServePlanKey } from "@giftforward/entitlements";
import { OnboardingPlans } from "./OnboardingPlans";

interface OnboardingPlanStepProps {
  error: string | null;
  isSubmitting: boolean;
  onPickStarter: () => void;
  onPickPlan: (plan: SelfServePlanKey) => void;
}

/**
 * The plan step. The cards themselves are `OnboardingPlans`, which renders from the shared
 * `PLAN_DISPLAY` — no hook, no request, no loading or error state to get wrong.
 *
 * This used to call `usePlans()`. That put a signup screen behind an authenticated round trip, and
 * `GET /plans` needs a local user row the caller does not have yet at signup, so it 401'd and the
 * cards showed a price and a button above nothing.
 *
 * `error` is the WIZARD's error — a failed account setup — not a failure to load plans, which can
 * no longer happen.
 */
export function OnboardingPlanStep({
  error,
  isSubmitting,
  onPickStarter,
  onPickPlan,
}: OnboardingPlanStepProps) {
  return (
    <div className="gfg-ob-panel-in">
      <h1 className="gfg-auth-title">Choose your plan</h1>
      <p className="gfg-auth-sub">Pick the best Gifts for Good experience for your team.</p>
      {error && (
        <p
          className="gfg-auth-hint"
          role="alert"
          style={{ color: "var(--color-good-wine)", marginTop: 8 }}
        >
          {error}
        </p>
      )}
      <OnboardingPlans
        isSubmitting={isSubmitting}
        onPickStarter={onPickStarter}
        onPickPlan={onPickPlan}
      />
    </div>
  );
}
